<template>
  <navigation-bar :dark-mode="true"/>
  <text-component />
  <FooterBar />
</template>

<script>
import NavigationBar from "@/components/common/navigation.vue";
import TextComponent from "@/components/gallery/description.vue";
import FooterBar from "@/components/common/footer.vue";

export default {
  components: {
    NavigationBar,
    TextComponent,
    FooterBar
  }
};
</script>
